module.exports = "<p>\n  work-flow works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/components/screens/contact/customer-detail/work-flow/work-flow.component.html
// module id = ../../../../../src/app/crm/components/screens/contact/customer-detail/work-flow/work-flow.component.html
// module chunks = main